import get from 'lodash.get';

export const selectRejectedFullfillmentPlans = (state) => get(state, 'fulfillmentPlansInOtherBatches');
